import React from 'react';

import { ExceptionIcon } from 'components/Icons';
import { BlueprintDetailCard } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/BlueprintDetailCard';
import { useBlueprintsContext } from 'containers/PolicyHub/Blueprints/hooks/context';

export const Exceptions: React.FC = () => {
  const { setShowExceptions } = useBlueprintsContext();
  return (
    <BlueprintDetailCard
      icon={<ExceptionIcon />}
      label="Exceptions"
      onClick={() => setShowExceptions(true)}
    />
  );
};
